import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { Seo } from "@/components/common/Seo";
import { useTranslate } from "@/i18n";

const VillkorPage = () => {
  const t = useTranslate();
  return (
    <div className="flex min-h-screen flex-col">
      <Seo title={t("terms.seoTitle")} description={t("terms.seoDescription")} />
      <SiteHeader />
      <main className="flex-1 container max-w-2xl py-16 md:py-24">
        <h1 className="font-display text-2xl md:text-3xl font-medium text-foreground mb-6">{t("terms.title")}</h1>
        <p className="text-muted-foreground leading-relaxed">
          {t("terms.body")}{" "}
          <a
            href="mailto:hello@farmly.se"
            className="underline underline-offset-4 hover:text-foreground transition-colors"
          >
            hello@farmly.se
          </a>.
        </p>
      </main>
      <SiteFooter />
    </div>
  );
};

export default VillkorPage;
